import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { supabase } from '@/supabaseClient';

export default function Login() {

  const [loading, setLoading] = useState(false);

  const [loginData, setLoginData] = useState({ email: '', password: '', company_slug: '' });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 1. Authenticate with Supabase
      const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
        email: loginData.email,
        password: loginData.password,
      });

      if (authError) throw authError;

      // 2. Verification: Check if user belongs to the requested company
      // We need to fetch the user's profile and company
      const userId = authData.user.id;

      const { data: userData, error: userError } = await supabase
        .from('users')
        .select(`
          *,
          companies (
            slug
          )
        `)
        .eq('id', userId)
        .single();

      if (userError || !userData) {
        await supabase.auth.signOut();
        throw new Error('No se encontró perfil de usuario para esta cuenta.');
      }

      if (userData.companies?.slug !== loginData.company_slug) {
        await supabase.auth.signOut();
        throw new Error(`Este usuario no pertenece a la empresa '${loginData.company_slug}'.`);
      }

      toast.success('¡Bienvenido!');
    } catch (error) {
      toast.error(error.message || 'Error al iniciar sesión');
      // Ensure specific cleanup if needed
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div
        className="hidden lg:flex lg:w-1/2 bg-cover bg-center"
        style={{
          backgroundImage: 'url(/login-bg.png)'
        }}
      />

      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-background">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <h1 className="text-4xl font-bold text-primary mb-2">Mini ERP</h1>
            <p className="text-muted-foreground">Sistema de contabilidad inteligente</p>
          </div>

          <Card>
            <CardHeader>
              <CardTitle>Iniciar Sesión</CardTitle>
              <CardDescription>Ingresa tu ID de empresa y credenciales</CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleLogin} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="company-slug">ID Empresa (Slug)</Label>
                  <Input
                    id="company-slug"
                    placeholder="ej: logika"
                    value={loginData.company_slug}
                    onChange={(e) => setLoginData({ ...loginData, company_slug: e.target.value })}
                    required
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="login-email">Email</Label>
                  <Input
                    id="login-email"
                    type="email"
                    placeholder="tu@email.com"
                    value={loginData.email}
                    onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
                    required
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="login-password">Contraseña</Label>
                  <Input
                    id="login-password"
                    type="password"
                    value={loginData.password}
                    onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                    required
                  />
                </div>
                <Button type="submit" className="w-full" disabled={loading}>
                  {loading ? 'Ingresando...' : 'Iniciar Sesión'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}